import { render, staticRenderFns } from "./ConfirmationPaypal.vue?vue&type=template&id=547bbe16&"
import script from "./ConfirmationPaypal.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPaypal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports